import React, {useRef, useEffect, useState, useContext} from 'react';
import {Handle} from 'reactflow';
//import {Handle} from 'react-flow-renderer';
import {Chatbot} from '../../states/actions';
import {useSelector, shallowEqual} from 'react-redux';
import {onEdit, onSetStart, onClose, onRemove, isLightColor} from '../../helpers/block-helper';
import {acceptedFileTypes} from '../../config';
import {ColorPicker} from '../ColorPicker';
import Select from 'react-select';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';
import {ckEditorBasic} from '../../config';
import {User} from '../../states/actions';
import {InputComponent, SelectComp, TextareaComponent, PreviewComponent, NodeComponent, SelectComponent, onEdited} from './Components'
import { GlobalStateContext } from '../GlobalState';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';

const zoomSelector = (s) => s.transform[2];


export const UploadBlock = React.memo((node) => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);  
  const {block, start, review, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress};
  const {_id} = useSelector(User.get());
  const [previewMode, setPreviewMode] = useState(globalState.preview ? undefined : false);


  useEffect(() => {
    setPreviewMode(globalState.preview);
}, [globalState.preview]);

  if (!block) {
    return null;
  }
  const {data} = block;


  return (
    <>

      {!previewMode &&(
          
          <NodeComponent bot={bot} block={block} name="Upload" icon="upload" data={data} node={node} start={start} />
      )}

      {previewMode && (
       // <div className={`block-body node`} onClick={review ? null : () => onEdit(node)}>
              <PreviewComponent bot={bot} data={data} node={node} start={start}/>
       // </div>
      )}

    
    </>
  );
});

export const UploadEditor = ({nodeid, block, data, options}) => {


  if (!block) {
    return null;
  }


 
  const handleBlur = (e) => {   
    Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
  };
  return(
    <>
              
              <div className='section'>UPLOAD</div>


              <InputComponent data={data} name="Upload file name" dataname="filePrefix" onBlur={handleBlur}/>
              <InputComponent data={data} name="File size limit (mb)" dataname="sizeLimit" onBlur={handleBlur}/>
              <InputComponent
                data={data}
                name="Max files (0 = unlimited, 1 = single file for AI)"
                dataname="maxFiles"
                onBlur={handleBlur}
              />

              <div className="form-check my-3">
                <input
                  type="checkbox"
                  id="backgroundUpload"
                  name="backgroundUpload"
                  className="form-check-input"
                  checked={!!data.backgroundUpload}
                  onChange={(e) => {
                    Chatbot.setBlockData(block.id, {backgroundUpload: e.target.checked});
                    onEdited();
                  }}
                />
                <label htmlFor="backgroundUpload" className="form-check-label">
                  Run in background
                </label>
                <div className="form-text">
                  User continues immediately; later blocks wait automatically if they need the files.
                </div>
              </div>

                <label htmlFor="fileSizeLimit" className="form-label">
                  Accepted File Type
                </label>
                <Select
                  id="acceptedTypes"
                  name="acceptedTypes"
                  placeholder="Select File Type"
                  className=" form-control-sm editor-select"
                  
                  classNamePrefix="editor-select"
                 
                  isMulti
                  options={acceptedFileTypes}
                  value={acceptedFileTypes.filter((item) => data?.acceptedTypes?.includes(item.value))}
                  onChange={(option) => {
                    Chatbot.setBlockData(block.id, {assign: {...data, acceptedTypes: option.map((i) => i.value)}});
                  }}
                />
              


    
    </>
  )

}